import { TeamMember } from '../../domain/models';

export interface TeamMemberEntity {
  id: string;
  team_id: string;
  user_id: string;
  joined_at: string;
  user_name: string;
  user_avatar_url: string | null;
}

export const teamMemberEntityToModel = (entity: TeamMemberEntity): TeamMember => ({
  id: entity.id,
  teamId: entity.team_id,
  userId: entity.user_id,
  userName: entity.user_name,
  userAvatarUrl: entity.user_avatar_url || undefined,
  joinedAt: new Date(entity.joined_at),
});
